<template>
    <div
        :data-component="$options.name"
        class="flex flex-wrap w-full"
    >
        <div
            v-for="timeframeOption in timeframeOptions"
            :key="timeframeOption.key"
            class="flex w-full screen-m:w-1/2"
        >
            <cs-radio-button
                v-model="model"
                name="timeframe-type"
                :value="timeframeOption.value"
                @update:modelValue="onUpdate"
            >
                {{ timeframeOption.text }}
            </cs-radio-button>
        </div>
    </div>
</template>
<script lang="ts" src="./CsTimeframe.ts" />
